import { sendToMixpanel } from '../../mixpanel';

const trackTotalReview = (): void => {
  sendToMixpanel('Click Total Reviews - RMA');
};

export default trackTotalReview;
